import { createContext } from 'react';

export const PostContext = createContext({
  posts: [],
  totalPosts: 0,
  fetchAllPosts: () => {},
});
